@if (userHasProcess) {
  <div class="container">
    <div class="panel-vertical">
      <div class="inline p-3">
        <form class="inline" #cryptForm="ngForm" (ngSubmit)="onSubmit()">
          <fieldset class="borderless" [disabled]="requestLoading">
            <mat-radio-group [(ngModel)]="selectedCrypt" name="cryptRadio" required>
              <mat-radio-button [value]="cryptEnum.encrypt" (change)="cryptRadioChange($event)">Encrypt</mat-radio-button>
              <mat-radio-button [value]="cryptEnum.decrypt" (change)="cryptRadioChange($event)">Decrypt</mat-radio-button>
            </mat-radio-group>
            <div>
              <mat-form-field subscriptSizing="dynamic">
                <mat-label>Process</mat-label>
                <mat-select [(ngModel)]="selectedProcess" required [disabled]="requestLoading" name="processSelect">
                  @for (process of processOptions; track process) {
                    <mat-option [value]="process">{{process}}</mat-option>
                  }
                </mat-select>
              </mat-form-field>
            </div>
            <div>
              <div class="mat-subtitle-1 my-2">File Upload</div>
              <mat-radio-group [(ngModel)]="selectedMultipleFileUpload" name="fileUploadRadio" required>
                <mat-radio-button [value]="false" (change)="fileUploadRadioChange($event)">Single File</mat-radio-button>
                <mat-radio-button [value]="true" (change)="fileUploadRadioChange($event)">Multiple Files
                </mat-radio-button>
              </mat-radio-group>
            </div>
            @if (selectedMultipleFileUpload) {
              <div class="mat-caption my-2">
                File Selection Limit: {{multipleFileSelectLimit}} Files
                <br/>
                File Size Limit Per File: {{multipleFileSelectLimitStr}}
              </div>
            }
            <div class="my-1">
              <button type="button" mat-raised-button color="primary"
              (click)="fileInput.click()">{{selectedMultipleFileUpload ? 'Choose Files' : 'Choose File'}}</button>
              <span
              class="file-name">{{selectedFiles.length > 1 ? selectedFiles.length + ' files' : selectedFiles[0]?.name}}</span>
              <input hidden [multiple]="selectedMultipleFileUpload" (click)="onFileClick($event)"
                (change)="onFileSelect($event)" #fileInput type="file"/>
              </div>
            </fieldset>
            @if (selectedFiles.length > 1) {
              <div>
                <div class="mat-subtitle-1 my-2">Files Selected</div>
                <div class="file-select-container">
                  <div class="file-select-list">
                    @for (file of selectedFiles; track file; let isLast = $last) {
                      <span>
                      {{isLast ? file.name : file.name + ','}}</span>
                    }
                  </div>
                </div>
              </div>
            }
            <div class="my-1">
              <button mat-raised-button class="mr-1" color="primary" type="submit"
                [disabled]="!cryptForm.valid || !(selectedFiles.length > 0) || requestLoading">
                Execute
              </button>
              @if (requestLoading) {
                <button mat-raised-button color="warn" type="button" (click)="cancelRequest()">
                  <mat-icon>cancel</mat-icon>
                  Cancel
                </button>
              }
            </div>
          </form>
        </div>
      </div>
      <div class="panel-vertical">
        <div class="download-panel">
          @if (!requestLoading && downloadHref) {
            <a class="download" [href]="downloadHref" [download]="downloadName">
              <mat-icon>insert_drive_file</mat-icon>
              {{downloadName}}
            </a>
          }
          @if (requestLoading) {
            <mat-progress-spinner [diameter]="50" mode="indeterminate"></mat-progress-spinner>
          }
        </div>
        @if (errorList.length > 0) {
          <div class="px-3 mb-2">
            <div class="mat-headline-6 mb-1">Errors</div>
            <div class="mat-caption">See error file for full details.</div>
            <div class="error-list">
              <mat-accordion>
                @for (error of errorList; track error) {
                  <mat-expansion-panel>
                    <mat-expansion-panel-header>
                      <mat-panel-title>
                        {{error.fileName}}
                      </mat-panel-title>
                      <mat-panel-description>
                        {{'Error Code: ' + error.errorCode}}
                      </mat-panel-description>
                    </mat-expansion-panel-header>
                    {{error.message}}
                  </mat-expansion-panel>
                }
              </mat-accordion>
            </div>
          </div>
        }
      </div>
    </div>
  }
